import type { CSSProperties, HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./Stack.module.css";

export type SpaceToken = 4 | 8 | 12 | 16 | 24 | 36;

const gapClass: Record<SpaceToken, string> = {
  4: styles.gap4,
  8: styles.gap8,
  12: styles.gap12,
  16: styles.gap16,
  24: styles.gap24,
  36: styles.gap36,
};

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  gap?: SpaceToken;
  align?: CSSProperties["alignItems"];
}

export function Stack({
  children,
  className,
  gap = 16,
  align,
  style,
  ...rest
}: StackProps) {
  return (
    <div
      className={cn(styles.stack, gapClass[gap], className)}
      style={{ ...style, ...(align ? { alignItems: align } : {}) }}
      {...rest}
    >
      {children}
    </div>
  );
}
